/**
 * The manager note's three sections, in display order — shared between the
 * live report (`ReviewReport.tsx`, editable) and the read-only rollup
 * (`PersonReviewHistory.tsx`) so both render the same labels in the same
 * order.
 */
export const MANAGER_NOTE_SECTIONS = [
  { key: "keepDoing", label: "Things to keep doing" },
  { key: "improve", label: "Things to improve" },
  { key: "goalsNextSteps", label: "Goals and next steps" },
] as const;

export function isManagerNoteSectionBlank(value: string | null): boolean {
  return !value || value.trim() === "";
}
